(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const btn = e.target.closest('.gallery-arrow');
    if (!btn) return;
    e.preventDefault();

    const wrapper = btn.closest('.product-gallery');
    if (!wrapper) return;

    const mediaList = wrapper.querySelector('.product-gallery__media-list');
    const allMedias = [...mediaList.querySelectorAll('.product-gallery__media:not([hidden])')];

    // 找到当前选中的
    const currentIndex = allMedias.findIndex(m => m.classList.contains('is-selected'));
    let nextIndex;

    if (btn.classList.contains('gallery-arrow--next')) {
        nextIndex = currentIndex < allMedias.length - 1 ? currentIndex + 1 : 0;
    } else {
        nextIndex = currentIndex > 0 ? currentIndex - 1 : allMedias.length - 1;
    }

    // 点击对应的 page-dot（Impact 原生逻辑）
    const galleryId = mediaList.id;
    const dots = wrapper.querySelectorAll(`page-dots[aria-controls="${galleryId}"] button:not([hidden])`);
    if (dots[nextIndex]) {
        dots[nextIndex].click();
        return;
    }

    // 兜底，直接点 media 元素本身
    allMedias[nextIndex]?.click();
});
  } catch(e) { console.error(e); }
})();

})();
